import { type FC } from 'react'

import { useParams } from '@tanstack/react-router'

import { PromotionUpdateFormPage } from './PromotionUpdateFormPage'

export interface AdminPromotionUpdateFormPageProps {
  onDirtyChange?: (isDirty: boolean) => void
}

export const AdminPromotionUpdateFormPage: FC<AdminPromotionUpdateFormPageProps> = ({ onDirtyChange }) => {
  const { initiativeId, promotionId } = useParams({ from: '/promotions/$initiativeId/national/$promotionId' })

  return (
    <PromotionUpdateFormPage
      initiativeId={initiativeId}
      promotionId={promotionId}
      metadata={{ initiativeId, promotionId }}
      onDirtyChange={onDirtyChange}
    />
  )
}
